module.exports = __webpack_public_path__ + "static/logo_dark-dd9cd8a4969705f9173488f400909fda.png";